import { 
    Chart as ChartJS, 
    CategoryScale, 
    LinearScale, 
    LineElement, 
    PointElement,
    Filler, 
    Title, 
    Tooltip, 
    Legend 
} from 'chart.js'; 
import moment from 'moment';
import { ChartData, Event } from "../types/types"; 

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Filler,
    Title,
    Tooltip,
    Legend,
);

// Função para gerar dados do gráfico
export const generateChartData = (chartData: Event[]): { 
    chartData: ChartData; 
    totalCount: number; 
    cumulativeOK: number[]; 
    cumulativeNOk: number[]; 
    averageAccuracy: number;     
    deviceId:  number;
} => {

    chartData = chartData.sort((a, b) => Date.parse(a.eventDate) - Date.parse(b.eventDate)); 
    
    const deviceId = chartData.length > 0 ? chartData[0].deviceId : 0; 

    const ok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const notOk: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const total: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; 
    
    chartData.forEach((event) => { 
        let hourCulture = moment(event.eventDate).subtract(3, 'hours').toDate()
        let hour = hourCulture.getHours() 
        if(event.status) {
            ok[hour] = ok[hour] + 1
        } else {
            notOk[hour] = notOk[hour] + 1
        } 
        total[hour] = total[hour] + 1
    });   

    const count = chartData.reduce((acc, event) => {
        acc.trueCount += event.status ? 1 : 0;
        acc.falseCount += event.status ? 0 : 1;
        return acc;
    }, { trueCount: 0, falseCount: 0 });

    const totalCount = count.trueCount + count.falseCount; // Total de registros

    // Criar matrizes para os registros OK e NOK
    const okCounts = chartData.map(event => (event.status ? 1 : 0)); // Contagem de OK
    const noOKCounts = chartData.map(event => (!event.status ? 1 : 0)); // Contagem de NOK
    
    // Calcular precisão média
    // const accuracyValues = chartData.map(event => Number(event.accuracy));
    // const averageAccuracy = accuracyValues.reduce((acc, curr) => acc + curr, 0) / accuracyValues.length || 0;
    const averageAccuracy = (count.trueCount / (totalCount == 0 ? 1 : totalCount))*100 || 0;

    // Criar arrays cumulativos
    const cumulativeOK = createCumulativeArray(okCounts);
    const cumulativeNOk = createCumulativeArray(noOKCounts);
    //const cumulativeTotal = chartData.map((_, index) => index + 1);
    // Retornar os dados do gráfico e as contagens  
 

    return {
        chartData: {
            labels: ["00:00", "01:00", "02:00", "3:00", "4:00", "5:00", "6:00", "7:00", "8:00", "9:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
            datasets: [
                {
                    label: 'OK',
                    data: ok,
                    borderColor: '#28b85b',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    fill: false,
                },
                {
                    label: 'NOK',
                    data: notOk,
                    borderColor: '#940758',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    fill: false,
                },
                {
                    label: 'Total',
                    data: total,
                    borderColor: '#0F5C38',
                    backgroundColor: '#23494a',
                    fill: true,
                },
            ],
        },
        totalCount,
        cumulativeOK,
        cumulativeNOk,
        averageAccuracy,
        deviceId
    };
};

const createCumulativeArray = (data: number[]): number[] => {
    return data.reduce((acc: number[], curr: number) => {
        const lastValue = acc.length ? acc[acc.length - 1] : 0;
        acc.push(lastValue + curr);
        return acc;
    }, []);
};
